import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'gen',
    redirect: '/pay',
    component: () => import( /* webpackChunkName: "subPay" */ '../views/recharge.vue'),
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../views/recharge.vue'),
  },
  {
    path: '/scanToPay',
    name: 'scanToPay',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../components/scanToPay.vue'),
  },
  {
    path: '/shortMessage',
    name: 'ShortMessage',
    component: () => import( /* webpackChunkName: "scanToPay" */ '../components/shortMessage.vue'),
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router